import React from 'react';
import { Dialog, AppBar, Toolbar, IconButton, Typography, Slide } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const dashboardPage = [
  {
    key: 'issues',
    id: '8aa7fad7e760048438b2'
  },
  {
    key: 'rfis',
    id: 'f1b197c06c703bbc4c2e'
  },
  {
    key: 'submittals',
    id: 'b5894c106a02e262b09b'
  }
];

const tableMapping = {
  issues: 'Fact_issues',
  rfis: 'Fact_rfis',
  submittals: 'Fact_submittal'
};

const PowerBIDialog = ({ open, onClose, pageName, metadata }) => {
  const type = dashboardPage.find((res) => res.key === pageName);
  const baseUrl =
    'https://app.powerbi.com/reportEmbed?reportId=e8ebf975-5063-4beb-a2e7-709ade04f180&autoAuth=true&ctid=b161c897-0ae2-42a0-be86-8f7e36f2049f';

  const tableName = tableMapping[pageName] || '';
  const rawProjectId = metadata?.project_id || metadata?.projectId || '';
  // Handle 'b.' prefix commonly found in Autodesk project IDs
  const projectId = rawProjectId.startsWith('b.') ? rawProjectId.substring(2) : rawProjectId;

  let finalUrl = type ? `${baseUrl}&pageName=${type.id}&navContentPaneEnabled=false` : `${baseUrl}&navContentPaneEnabled=false`;

  if (tableName && projectId) {
    const filterValue = `${tableName}/project_id eq '${projectId}'`;
    finalUrl += `&filter=${encodeURIComponent(filterValue)}`;
  }

  return (
    <Dialog fullScreen open={open} onClose={onClose} TransitionComponent={Transition}>
      <AppBar sx={{ position: 'relative' }}>
        <Toolbar>
          <IconButton edge="start" color="inherit" onClick={onClose}>
            <CloseIcon />
          </IconButton>
          <Typography sx={{ ml: 2, flex: 1 }} variant="h6">
            Dashboard {type?.key.toUpperCase()}
          </Typography>
        </Toolbar>
      </AppBar>

      <iframe
        title="Power BI Report"
        width="100%"
        height="100%"
        src={finalUrl}
        frameBorder="0"
        allowFullScreen
        style={{ border: 'none' }}
      />
    </Dialog>
  );
};

export default PowerBIDialog;
